import * as React from "react";
import styled from "styled-components";

import {Long} from "protobufjs";
import {NavLink} from "react-router-dom";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
  ConstShadow,
} from "../../../../config/styles_const/styles_const";
import {Message} from "../../../../domain/model/message";
import {Project} from "../../../../domain/model/project";
import AvatarSmall from "../../atom/avatar/avatar_small";
import LabelUnread from "../../atom/label/label_unread";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
    latestMessage?: Message;
    project: Project;
    linkURL: string;
    opponentAvatarURL: string;
    opponentName: string;
    unRead: boolean;
    unReadCount: number | Long;
    isScout: boolean;
    isInitialActive: boolean;
}

const MessageRoomCard: React.FC<IProps> = (props: IProps) => {
    const {
        latestMessage,
        project,
        linkURL,
        opponentAvatarURL,
        opponentName,
        unRead,
        unReadCount,
        isScout,
        isInitialActive,
    } = props;

    const projectName: string = project.name;
    const latestMessageDateString: string | undefined = latestMessage
        ? latestMessage.getCreatedAtString()
        : undefined;

    return (
        <CardLink
            to={linkURL}
            exact={true}
            className={isInitialActive ? `active` : undefined}
        >
            <Wrapper>
                <Area area={"scout"}>
                    {isScout ? <Scout>スカウト</Scout> : <Entry>エントリー</Entry>}
                </Area>
                <Area area={"alert"}>
                    {unRead && <LabelUnread unReadCount={unReadCount}/>}
                </Area>
                <Area area={"datetime"}>
                    <Datetime>{latestMessageDateString}</Datetime>
                </Area>
                <Area area={"avatarIcon"}>
                    <AvatarIcon src={opponentAvatarURL}/>
                </Area>
                <Area area={"name"}>
                    <Name bold={true}>{opponentName}</Name>
                </Area>
                <Area area={"sub"}>
                    <Flex>
                        <Sub>{projectName}</Sub>
                    </Flex>
                </Area>
                {/*<Area area={"text"}><Text>{latestMessageText}</Text></Area>*/}
            </Wrapper>
        </CardLink>
    );
};

export default MessageRoomCard;

const template = `
    " ... ...        ...   scout datetime datetime  ... "
    " ... avatarIcon name  name  name     name      ... "
    " ... avatarIcon ...   ...   ...      alert     ... "    
    " ... avatarIcon sub   sub   sub      sub       ... "
`;

const Wrapper = styled.div`
    position: relative;
    padding-top: 5px;
    padding-bottom: 10px;
    margin: 5px auto;
    width: 100%;
    filter: drop-shadow(${ConstShadow.DropShadow});
    background-color: ${ConstColor.White};
    border-radius: ${ConstBorderRound.MessageRoomCard};

    display: grid;
    grid-template-areas: ${template};
    grid-template-columns: 10px auto 1fr auto auto auto 5px;
    grid-template-rows: auto auto auto auto;
    grid-column-gap: 0;
    grid-row-gap: 0;
    justify-content: center;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        filter: none;
        justify-content: center;
    }
`;

const Name = styled(ParagraphSup)`
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const Sub = styled(ParagraphSup)`
    position: relative;
    color: ${ConstColor.Gray};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const CardLink = styled(NavLink)`
    width: 100%;

    ${Wrapper}:hover {
        background-color: rgba(217, 217, 217, 0.3);
    }

    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        &.active ${Wrapper} {
            background-color: ${ConstColor.DeepBlack};
        }

        &.active ${Name} {
            color: ${ConstColor.White};
        }

        &.active ${Sub} {
            color: ${ConstColor.White};
        }

        &.active:hover ${Wrapper} {
            background-color: #515355;
        }
    }
`;

const Flex = styled.div`
    display: flex;
`;

const Scout = styled.span`
    color: ${ConstColor.Corporate};
    font-style: normal;
    font-weight: bold;
    font-size: 9px;
    line-height: 18px;
    margin-right: 5px;
`;

const Entry = styled.span`
    color: ${ConstColor.Success};
    font-style: normal;
    font-weight: bold;
    font-size: 9px;
    line-height: 18px;
    margin-right: 5px;
`;

const Area = styled.div<{ area: string }>`
    grid-area: ${(props) => props.area};
    display: grid;
    align-items: center;
`;

const Datetime = styled.span`
    color: ${ConstColor.Gray};
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 10px;
`;

const AvatarIcon = styled(AvatarSmall)`
    margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/card/message_room_card.tsx